//Todo: should be a json

import utils from "@/utils/utils";

const thumbnailDatas = [
    {
        id: 'antenna-01',
        svgs: {
            'grade-one': require('@/assets/image/buddy/gradeOneBuddy/Thumbnails/bb_g1_t_antenna-01.svg'),
            'grade-two': require('@/assets/image/buddy/gradeTwoBuddy/thumbnails/buddy_antenna-01.svg'),
            'grade-three': require('@/assets/image/buddy/gradeThreeBuddy/thumbnails/bb_g3_t_antenna-01.svg'),
        }
    },
    {
        id: 'antenna-02',
        svgs: {
            'grade-one': require('@/assets/image/buddy/gradeOneBuddy/Thumbnails/bb_g1_t_antenna-02.svg'),
            'grade-two': require('@/assets/image/buddy/gradeTwoBuddy/thumbnails/buddy_antenna-02.svg'),
            'grade-three': require('@/assets/image/buddy/gradeThreeBuddy/thumbnails/bb_g3_t_antenna-02.svg'),
        }
    },
    {
        id: 'antenna-03',
        svgs: {
            'grade-one': require('@/assets/image/buddy/gradeOneBuddy/Thumbnails/bb_g1_t_antenna-03.svg'),
            'grade-two': require('@/assets/image/buddy/gradeTwoBuddy/thumbnails/buddy_antenna-03.svg'),
            'grade-three': require('@/assets/image/buddy/gradeThreeBuddy/thumbnails/bb_g3_t_antenna-03.svg'),
        }
    },
    {
        id: 'antenna-04',
        svgs: {
            'grade-one': require('@/assets/image/buddy/gradeOneBuddy/Thumbnails/bb_g1_t_antenna-04.svg'),
            'grade-two': require('@/assets/image/buddy/gradeTwoBuddy/thumbnails/buddy_antenna-04.svg'),
            'grade-three': require('@/assets/image/buddy/gradeThreeBuddy/thumbnails/bb_g3_t_antenna-04.svg'),
        }
    },
    {
        id: 'antenna-05',
        svgs: {
            'grade-one': require('@/assets/image/buddy/gradeOneBuddy/Thumbnails/bb_g1_t_antenna-05.svg'),
            'grade-two': require('@/assets/image/buddy/gradeTwoBuddy/thumbnails/buddy_antenna-05.svg'),
            'grade-three': require('@/assets/image/buddy/gradeThreeBuddy/thumbnails/bb_g3_t_antenna-05.svg'),
        }
    },
    {
        id: 'antenna-06',
        svgs: {
            'grade-one': require('@/assets/image/buddy/gradeOneBuddy/Thumbnails/bb_g1_t_antenna-06.svg'),
            'grade-two': require('@/assets/image/buddy/gradeTwoBuddy/thumbnails/buddy_antenna-06.svg'),
            'grade-three': require('@/assets/image/buddy/gradeThreeBuddy/thumbnails/bb_g3_t_antenna-06.svg'),
        }
    },


    {
        id: 'ears-01',
        svgs: {
            'grade-one': require('@/assets/image/buddy/gradeOneBuddy/Thumbnails/bb_g1_t_ears-01.svg'),
            'grade-two': require('@/assets/image/buddy/gradeTwoBuddy/thumbnails/buddy_ears-01.svg'),
            'grade-three': require('@/assets/image/buddy/gradeThreeBuddy/thumbnails/bb_g3_t_ears-01.svg'),
        }
    },
    {
        id: 'ears-02',
        svgs: {
            'grade-one': require('@/assets/image/buddy/gradeOneBuddy/Thumbnails/bb_g1_t_ears-02.svg'),
            'grade-two': require('@/assets/image/buddy/gradeTwoBuddy/thumbnails/buddy_ears-02.svg'),
            'grade-three': require('@/assets/image/buddy/gradeThreeBuddy/thumbnails/bb_g3_t_ears-02.svg'),
        }
    },
    {
        id: 'ears-03',
        svgs: {
            'grade-one': require('@/assets/image/buddy/gradeOneBuddy/Thumbnails/bb_g1_t_ears-03.svg'),
            'grade-two': require('@/assets/image/buddy/gradeTwoBuddy/thumbnails/buddy_ears-03.svg'),
            'grade-three': require('@/assets/image/buddy/gradeThreeBuddy/thumbnails/bb_g3_t_ears-03.svg'),
        }
    },
    {
        id: 'ears-04',
        svgs: {
            'grade-one': require('@/assets/image/buddy/gradeOneBuddy/Thumbnails/bb_g1_t_ears-04.svg'),
            'grade-two': require('@/assets/image/buddy/gradeTwoBuddy/thumbnails/buddy_ears-04.svg'),
            'grade-three': require('@/assets/image/buddy/gradeThreeBuddy/thumbnails/bb_g3_t_ears-04.svg'),
        }
    },
    {
        id: 'ears-05',
        svgs: {
            'grade-one': require('@/assets/image/buddy/gradeOneBuddy/Thumbnails/bb_g1_t_ears-05.svg'),
            'grade-two': require('@/assets/image/buddy/gradeTwoBuddy/thumbnails/buddy_ears-05.svg'),
            'grade-three': require('@/assets/image/buddy/gradeThreeBuddy/thumbnails/bb_g3_t_ears-05.svg'),
        }
    },
    {
        id: 'ears-06',
        svgs: {
            'grade-one': require('@/assets/image/buddy/gradeOneBuddy/Thumbnails/bb_g1_t_ears-06.svg'),
            'grade-two': require('@/assets/image/buddy/gradeTwoBuddy/thumbnails/buddy_ears-06.svg'),
            'grade-three': require('@/assets/image/buddy/gradeThreeBuddy/thumbnails/bb_g3_t_ears-06.svg'),
        }
    },


    {
        id: 'eyes-01',
        svgs: {
            'grade-one': require('@/assets/image/buddy/gradeOneBuddy/Thumbnails/bb_g1_t_eyes-01.svg'),
            'grade-two': require('@/assets/image/buddy/gradeTwoBuddy/thumbnails/buddy_eyes-01.svg'),
            'grade-three': require('@/assets/image/buddy/gradeThreeBuddy/thumbnails/bb_g3_t_eyes-01.svg'),
        }
    },
    {
        id: 'eyes-02',
        svgs: {
            'grade-one': require('@/assets/image/buddy/gradeOneBuddy/Thumbnails/bb_g1_t_eyes-02.svg'),
            'grade-two': require('@/assets/image/buddy/gradeTwoBuddy/thumbnails/buddy_eyes-02.svg'),
            'grade-three': require('@/assets/image/buddy/gradeThreeBuddy/thumbnails/bb_g3_t_eyes-02.svg'),
        }
    },
    {
        id: 'eyes-03',
        svgs: {
            'grade-one': require('@/assets/image/buddy/gradeOneBuddy/Thumbnails/bb_g1_t_eyes-03.svg'),
            'grade-two': require('@/assets/image/buddy/gradeTwoBuddy/thumbnails/buddy_eyes-03.svg'),
            'grade-three': require('@/assets/image/buddy/gradeThreeBuddy/thumbnails/bb_g3_t_eyes-03.svg'),
        }
    },
    {
        id: 'eyes-04',
        svgs: {
            'grade-one': require('@/assets/image/buddy/gradeOneBuddy/Thumbnails/bb_g1_t_eyes-04.svg'),
            'grade-two': require('@/assets/image/buddy/gradeTwoBuddy/thumbnails/buddy_eyes-04.svg'),
            'grade-three': require('@/assets/image/buddy/gradeThreeBuddy/thumbnails/bb_g3_t_eyes-04.svg'),
        }
    },
    {
        id: 'eyes-05',
        svgs: {
            'grade-one': require('@/assets/image/buddy/gradeOneBuddy/Thumbnails/bb_g1_t_eyes-05.svg'),
            'grade-two': require('@/assets/image/buddy/gradeTwoBuddy/thumbnails/buddy_eyes-05.svg'),
            'grade-three': require('@/assets/image/buddy/gradeThreeBuddy/thumbnails/bb_g3_t_eyes-05.svg'),
        }
    },
    {
        id: 'eyes-06',
        svgs: {
            'grade-one': require('@/assets/image/buddy/gradeOneBuddy/Thumbnails/bb_g1_t_eyes-06.svg'),
            'grade-two': require('@/assets/image/buddy/gradeTwoBuddy/thumbnails/buddy_eyes-06.svg'),
            'grade-three': require('@/assets/image/buddy/gradeThreeBuddy/thumbnails/bb_g3_t_eyes-06.svg'),
        }
    },


    {
        id: 'nose-01',
        svgs: {
            'grade-one': require('@/assets/image/buddy/gradeOneBuddy/Thumbnails/bb_g1_t_nose-01.svg'),
            'grade-two': require('@/assets/image/buddy/gradeTwoBuddy/thumbnails/buddy_nose-01.svg'),
            'grade-three': require('@/assets/image/buddy/gradeThreeBuddy/thumbnails/bb_g3_t_nose-01.svg'),
        }
    },
    {
        id: 'nose-02',
        svgs: {
            'grade-one': require('@/assets/image/buddy/gradeOneBuddy/Thumbnails/bb_g1_t_nose-02.svg'),
            'grade-two': require('@/assets/image/buddy/gradeTwoBuddy/thumbnails/buddy_nose-02.svg'),
            'grade-three': require('@/assets/image/buddy/gradeThreeBuddy/thumbnails/bb_g3_t_nose-02.svg'),
        }
    },
    {
        id: 'nose-03',
        svgs: {
            'grade-one': require('@/assets/image/buddy/gradeOneBuddy/Thumbnails/bb_g1_t_nose-03.svg'),
            'grade-two': require('@/assets/image/buddy/gradeTwoBuddy/thumbnails/buddy_nose-03.svg'),
            'grade-three': require('@/assets/image/buddy/gradeThreeBuddy/thumbnails/bb_g3_t_nose-03.svg'),
        }
    },
    {
        id: 'nose-04',
        svgs: {
            'grade-one': require('@/assets/image/buddy/gradeOneBuddy/Thumbnails/bb_g1_t_nose-04.svg'),
            'grade-two': require('@/assets/image/buddy/gradeTwoBuddy/thumbnails/buddy_nose-04.svg'),
            'grade-three': require('@/assets/image/buddy/gradeThreeBuddy/thumbnails/bb_g3_t_nose-04.svg'),
        }
    },
    {
        id: 'nose-05',
        svgs: {
            'grade-one': require('@/assets/image/buddy/gradeOneBuddy/Thumbnails/bb_g1_t_nose-05.svg'),
            'grade-two': require('@/assets/image/buddy/gradeTwoBuddy/thumbnails/buddy_nose-05.svg'),
            'grade-three': require('@/assets/image/buddy/gradeThreeBuddy/thumbnails/bb_g3_t_nose-05.svg'),
        }
    },
    {
        id: 'nose-06',
        svgs: {
            'grade-one': require('@/assets/image/buddy/gradeOneBuddy/Thumbnails/bb_g1_t_nose-06.svg'),
            'grade-two': require('@/assets/image/buddy/gradeTwoBuddy/thumbnails/buddy_nose-06.svg'),
            'grade-three': require('@/assets/image/buddy/gradeThreeBuddy/thumbnails/bb_g3_t_nose-06.svg'),
        }
    },


    {
        id: 'mouth-01',
        svgs: {
            'grade-one': require('@/assets/image/buddy/gradeOneBuddy/Thumbnails/bb_g1_t_mouth-01.svg'),
            'grade-two': require('@/assets/image/buddy/gradeTwoBuddy/thumbnails/buddy_mouth-01.svg'),
            'grade-three': require('@/assets/image/buddy/gradeThreeBuddy/thumbnails/bb_g3_t_mouth-01.svg'),
        }
    },
    {
        id: 'mouth-02',
        svgs: {
            'grade-one': require('@/assets/image/buddy/gradeOneBuddy/Thumbnails/bb_g1_t_mouth-02.svg'),
            'grade-two': require('@/assets/image/buddy/gradeTwoBuddy/thumbnails/buddy_mouth-02.svg'),
            'grade-three': require('@/assets/image/buddy/gradeThreeBuddy/thumbnails/bb_g3_t_mouth-02.svg'),
        }
    },
    {
        id: 'mouth-03',
        svgs: {
            'grade-one': require('@/assets/image/buddy/gradeOneBuddy/Thumbnails/bb_g1_t_mouth-03.svg'),
            'grade-two': require('@/assets/image/buddy/gradeTwoBuddy/thumbnails/buddy_mouth-03.svg'),
            'grade-three': require('@/assets/image/buddy/gradeThreeBuddy/thumbnails/bb_g3_t_mouth-03.svg'),
        }
    },
    {
        id: 'mouth-04',
        svgs: {
            'grade-one': require('@/assets/image/buddy/gradeOneBuddy/Thumbnails/bb_g1_t_mouth-04.svg'),
            'grade-two': require('@/assets/image/buddy/gradeTwoBuddy/thumbnails/buddy_mouth-04.svg'),
            'grade-three': require('@/assets/image/buddy/gradeThreeBuddy/thumbnails/bb_g3_t_mouth-04.svg'),
        }
    },
    {
        id: 'mouth-05',
        svgs: {
            'grade-one': require('@/assets/image/buddy/gradeOneBuddy/Thumbnails/bb_g1_t_mouth-05.svg'),
            'grade-two': require('@/assets/image/buddy/gradeTwoBuddy/thumbnails/buddy_mouth-05.svg'),
            'grade-three': require('@/assets/image/buddy/gradeThreeBuddy/thumbnails/bb_g3_t_mouth-05.svg'),
        }
    },
    {
        id: 'mouth-06',
        svgs: {
            'grade-one': require('@/assets/image/buddy/gradeOneBuddy/Thumbnails/bb_g1_t_mouth-06.svg'),
            'grade-two': require('@/assets/image/buddy/gradeTwoBuddy/thumbnails/buddy_mouth-06.svg'),
            'grade-three': require('@/assets/image/buddy/gradeThreeBuddy/thumbnails/bb_g3_t_mouth-06.svg'),
        }
    },


    {
        id: 'whiskers-01',
        svgs: {
            'grade-one': null,
            'grade-two': require('@/assets/image/buddy/gradeTwoBuddy/thumbnails/buddy_whiskers-01.svg'),
            'grade-three': null,
        }
    },
    {
        id: 'whiskers-02',
        svgs: {
            'grade-one': null,
            'grade-two': require('@/assets/image/buddy/gradeTwoBuddy/thumbnails/buddy_whiskers-02.svg'),
            'grade-three': null,
        }
    },
    {
        id: 'whiskers-03',
        svgs: {
            'grade-one': null,
            'grade-two': require('@/assets/image/buddy/gradeTwoBuddy/thumbnails/buddy_whiskers-03.svg'),
            'grade-three': null,
        }
    },
    {
        id: 'whiskers-04',
        svgs: {
            'grade-one': null,
            'grade-two': require('@/assets/image/buddy/gradeTwoBuddy/thumbnails/buddy_whiskers-04.svg'),
            'grade-three': null,
        }
    },
    {
        id: 'whiskers-05',
        svgs: {
            'grade-one': null,
            'grade-two': require('@/assets/image/buddy/gradeTwoBuddy/thumbnails/buddy_whiskers-05.svg'),
            'grade-three': null,
        }
    },
    {
        id: 'whiskers-06',
        svgs: {
            'grade-one': null,
            'grade-two': require('@/assets/image/buddy/gradeTwoBuddy/thumbnails/buddy_whiskers-06.svg'),
            'grade-three': null,
        }
    },


    {
        id: 'item_01',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_01.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_01.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_01.svg'),
        }
    },
    {
        id: 'item_02',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_02.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_02.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_02.svg'),
        }
    },
    {
        id: 'item_03',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_03.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_03.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_03.svg'),
        }
    },
    {
        id: 'item_04',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_04.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_04.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_04.svg'),
        }
    },
    {
        id: 'item_05',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_05.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_05.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_05.svg'),
        }
    },
    {
        id: 'item_06',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_06.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_06.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_06.svg'),
        }
    },

    {
        id: 'item_07',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_07.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_07.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_07.svg'),
        }
    },

    {
        id: 'item_08',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_08.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_08.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_08.svg'),
        }
    },

    {
        id: 'item_09',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_09.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_09.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_09.svg'),
        }
    },

    {
        id: 'item_10',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_10.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_10.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_10.svg'),
        }
    },

    {
        id: 'item_11',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_11.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_11.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_11.svg'),
        }
    },
    {
        id: 'item_12',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_12.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_12.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_12.svg'),
        }
    },
    {
        id: 'item_13',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_13.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_13.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_13.svg'),
        }
    },
    {
        id: 'item_14',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_14.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_14.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_14.svg'),
        }
    },
    {
        id: 'item_15',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_15.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_15.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_15.svg'),
        }
    },
    {
        id: 'item_16',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_16.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_16.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_16.svg'),
        }
    },
    {
        id: 'item_17',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_17.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_17.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_17.svg'),
        }
    },
    {
        id: 'item_18',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_18.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_18.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_18.svg'),
        }
    },

    {
        id: 'hat_01',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_hat_01.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_hat_01.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_hat_01.svg'),
        }
    },
    {
        id: 'hat_02',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_hat_02.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_hat_02.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_hat_02.svg'),
        }
    },
    {
        id: 'hat_03',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_hat_03.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_hat_03.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_hat_03.svg'),
        }
    },
    {
        id: 'hat_04',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_hat_04.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_hat_04.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_hat_04.svg'),
        }
    },
    {
        id: 'hat_05',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_hat_05.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_hat_05.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_hat_05.svg'),
        }
    },
    {
        id: 'hat_06',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_hat_06.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_hat_06.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_hat_06.svg'),
        }
    },

    {
        id: 'hat_07',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_hat_07.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_hat_07.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_hat_07.svg'),
        }
    },

    {
        id: 'hat_08',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_hat_08.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_hat_08.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_hat_08.svg'),
        }
    },

    {
        id: 'hat_09',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_hat_09.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_hat_09.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_hat_09.svg'),
        }
    },

    {
        id: 'hat_10',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_hat_10.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_hat_10.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_hat_10.svg'),
        }
    },

    {
        id: 'hat_11',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_hat_11.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_hat_11.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_hat_11.svg'),
        }
    },
    {
        id: 'hat_12',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_hat_12.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_hat_12.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_hat_12.svg'),
        }
    },
    {
        id: 'hat_13',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_hat_13.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_hat_13.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_hat_13.svg'),
        }
    },


    {
        id: 'pants_01',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_pants_01.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_pants_01.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_pants_01.svg'),
        }
    },
    {
        id: 'pants_02',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_pants_02.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_pants_02.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_pants_02.svg'),
        }
    },
    {
        id: 'pants_03',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_pants_03.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_pants_03.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_pants_03.svg'),
        }
    },
    {
        id: 'pants_04',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_pants_04.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_pants_04.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_pants_04.svg'),
        }
    },
    {
        id: 'pants_05',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_pants_05.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_pants_05.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_pants_05.svg'),
        }
    },
    {
        id: 'pants_06',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_pants_06.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_pants_06.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_pants_06.svg'),
        }
    },

    {
        id: 'pants_07',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_pants_07.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_pants_07.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_pants_07.svg'),
        }
    },

    {
        id: 'pants_08',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_pants_08.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_pants_08.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_pants_08.svg'),
        }
    },

    {
        id: 'pants_09',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_pants_09.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_pants_09.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_pants_09.svg'),
        }
    },


    {
        id: 'shirt_01',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_01.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_01.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_01.svg'),
        }
    },
    {
        id: 'shirt_02',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_02.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_02.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_02.svg'),
        }
    },
    {
        id: 'shirt_03',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_03.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_03.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_03.svg'),
        }
    },
    {
        id: 'shirt_04',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_04.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_04.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_04.svg'),
        }
    },
    {
        id: 'shirt_05',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_05.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_05.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_05.svg'),
        }
    },
    {
        id: 'shirt_06',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_06.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_06.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_06.svg'),
        }
    },

    {
        id: 'shirt_07',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_07.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_07.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_07.svg'),
        }
    },

    {
        id: 'shirt_08',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_08.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_08.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_08.svg'),
        }
    },

    {
        id: 'shirt_09',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_09.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_09.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_09.svg'),
        }
    },

    {
        id: 'shirt_10',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_10.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_10.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_10.svg'),
        }
    },

    {
        id: 'shirt_11',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_11.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_11.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_11.svg'),
        }
    },
    {
        id: 'shirt_12',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_12.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_12.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_12.svg'),
        }
    },
    {
        id: 'shirt_13',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_13.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_13.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_13.svg'),
        }
    },
    {
        id: 'shirt_14',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_14.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_14.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_14.svg'),
        }
    },
    {
        id: 'shirt_15',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_15.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_15.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_15.svg'),
        }
    },


    {
        id: 'shoe_01',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shoe_01.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shoe_01.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shoe_01.svg'),
        }
    },
    {
        id: 'shoe_02',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shoe_02.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shoe_02.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shoe_02.svg'),
        }
    },
    {
        id: 'shoe_03',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shoe_03.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shoe_03.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shoe_03.svg'),
        }
    },
    {
        id: 'shoe_04',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shoe_04.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shoe_04.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shoe_04.svg'),
        }
    },
    {
        id: 'shoe_05',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shoe_05.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shoe_05.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shoe_05.svg'),
        }
    },
    {
        id: 'shoe_06',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shoe_06.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shoe_06.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shoe_06.svg'),
        }
    },

    {
        id: 'shoe_07',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shoe_07.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shoe_07.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shoe_07.svg'),
        }
    },
    //Winter games
    {
        id: 'hat_14',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_hat_14.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_hat_14.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_hat_14.svg'),
        }
    },
    {
        id: 'hat_15',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_hat_15.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_hat_15.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_hat_15.svg'),
        }
    },
    {
        id: 'item_17',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_17.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_17.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_17.svg'),
        }
    },
    {
        id: 'item_18',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_18.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_18.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_item_18.svg'),
        }
    },
    {
        id: 'pants_10',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_pants_10.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_pants_10.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_pants_10.svg'),
        }
    },
    {
        id: 'shirt_14',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_14.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_14.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_14.svg'),
        }
    },
    {
        id: 'shirt_15',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_15.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_15.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shirt_15.svg'),
        }
    },
    {
        id: 'shoe_08',
        svgs: {
            'grade-one': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shoe_08.svg'),
            'grade-two': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shoe_08.svg'),
            'grade-three': require('@/assets/image/accessories/Accessories_G2/thumbnails/accessory_shoe_08.svg'),
        }
    }

];


const parser = new DOMParser();

export default class ThumbnailLibrary {

    static getThumbFromFile(id, grade)
    {
        //console.log("getting thumb for " + id + " and grade " + grade);
        return new Promise((resolve) => {

            let thumbLocation = this.getThumbnailLocationForGrade(grade, id);
            fetch(thumbLocation)
                .then(r => r.text())
                .then(text => {
                    let doc = parser.parseFromString(text, "image/svg+xml");
                    let svgEL = doc.getElementsByTagNameNS("http://www.w3.org/2000/svg", "svg").item(0);
                    let resultObject = {
                        id: id,
                        svg: svgEL
                    }
                    resolve(resultObject);
                })
                .catch(console.error.bind(console));
        });
    }

    static getThumbnailLocationForGrade(schoolYear, id)
    {
        //logger.info("getting body part location for id " + id + " and grade " + grade)
        let data = this.findDataForId(id);

        if (data == null)
        {
            console.log("data was null for " + id + " grade: " + schoolYear)
            return null;
        }
        
        let location = null;

        let grade = utils.getGradeForSchoolYear(schoolYear);

        switch (grade)
        {
            case 1:
                location = data.svgs['grade-one'];
                break;
            case 2:
                location = data.svgs['grade-two'];
                break;
            case 3:
                location = data.svgs['grade-three'];
                break;
        }
        return location;
    }

    static findDataForId(id)
    {
        let result = null;
        thumbnailDatas.forEach(data =>
        {
            if (data.id === id)
            {
                result = data;
            }
        });
        return result;
    }
}

